const phoneFieldStyles = theme => ({
  phoneField: {
    width: theme.spacing(2.5),
    background: 'white !important',
    border: '0px  !important',
    borderRadius: '0 !important',
    borderBottom: '1px solid rgba(0, 0, 0, 0.42) !important',
    '& div': {
      padding: '0px !important',
      pointerEvents: 'none',
      '&:hover': {
        backgroundColor: 'transparent !important'
      }
    },
    '&:hover': {
      borderBottom: '2px solid rgba(0, 0, 0, 0.87) !important'
    },
    '&:focus': {
      borderBottom: '2px solid #F3731F !important'
    }
  },
  errorClass: {
    borderBottom: '2px solid #f44336 !important',
    '&:hover': {
      borderBottom: '2px solid #f44336 !important'
    },
    '&:focus': {
      borderBottom: '2px solid #f44336 !important'
    }
  },
  phoneInputField: {
    width: '100% !important',
    height: '27px !important',
    paddingLeft: `${theme.spacing(4)}px !important`
  }
});

export default phoneFieldStyles;
